


















import { defineComponent} from '@vue/composition-api'
import PageBuilderComponent from '~/mixins/solepro/PageBuilderComponent.vue';
import { ImageType } from '~/types/solepro/PageBuilder';
export default defineComponent({
    mixins: [PageBuilderComponent],
    props: {
        node: {
            type: Object,
            required: true
        },
    },
    setup(props) {
        //props.node.DOMContent.querySelectorAll('img').forEach(el=>el.classList+=content.cssClasses)
        const content = props.node as ImageType;
        return {
            content
        }
    }
})
